import React from "react";
import "./ProductDetails.css"; // Ümumi CSS faylı

function AccessoriesDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="product-details">
            <h3 className="product-details-title">Aksesuar Məhsul Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Ad:</strong> {product.name || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Kategoriya:</strong> {product.category || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Tür:</strong> {product.type || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Material:</strong> {product.material || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Brend:</strong> {product.brand || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Vəziyyət:</strong> {product.condition || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default AccessoriesDetails;
